/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-03-10 17:53:42
 *
 *******************************************************/
//@flow

import _ from 'lodash';

import React, { Component } from 'react';
import { Card, TextStyle, Heading, SkeletonBodyText } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { connect } from 'react-redux';
import { Carousel } from 'src/components/views/common/carousel';
import { PARTNERS_POWERUP } from 'src/constants/dashboard-v4';

type Props = {
  tenantApp: Object,
  subscription: Object
};

type ComposedProps = Props & WithI18nProps;
class RecommendedApps extends Component<ComposedProps> {
  render() {
    const { i18n, inAppSpotlightLoading } = this.props;
    const partnersPowerUp = _.sampleSize(PARTNERS_POWERUP, 5);
    const renderListItem = partnersPowerUp.map((app, idx) => {
      const { logo, title, link, description } = app;
      const gotoApp = () => window.open(link, '_blank');
      return (
        <div className="item" key={idx}>
          <div className="img">
            <img onClick={gotoApp} className="icon" src={logo} alt={i18n.translate(title)} />
          </div>
          <div className="title" style={{ display: 'flex', alignItems: 'center' }}>
            <span onClick={gotoApp}>{i18n.translate(title)}</span>
          </div>
          <div className="description">{i18n.translate(description)}</div>
        </div>
      );
    });

    return (
      <div className="BC-RecommendedApps__DashboardV3 V4">
        <Card sectioned>
          <Heading>{i18n.translate('AdminHTML.DashboardV3.RecommendedApps.v2_cardTitle')}</Heading>
          <TextStyle variation="subdued">
            {i18n.translate('AdminHTML.DashboardV3.RecommendedApps.v2_cardDescription')}
          </TextStyle>
          {inAppSpotlightLoading ? (
            <div style={{ paddingTop: '10px' }}>
              <SkeletonBodyText lines={5} />
            </div>
          ) : (
            <Carousel items={renderListItem} autoDisplay={true} timeInterval={9000} />
          )}
        </Card>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  const tenantApp = _.get(state.oauth, 'tenantApp', {});
  return {
    tenantApp,
    subscription: _.get(state.oauth, 'subscription', {}),
    inAppSpotlightLoading: _.get(state.dashboardV3, 'inAppSpotlightLoading', false)
  };
};

const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(withI18n()(RecommendedApps));
